import { render } from "./CodingPlatforms.vue?vue&type=template&id=12010efc&scoped=true"
import script from "./CodingPlatforms.vue?vue&type=script&lang=js"
export * from "./CodingPlatforms.vue?vue&type=script&lang=js"

import "./CodingPlatforms.vue?vue&type=style&index=0&id=12010efc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12010efc"]])

export default __exports__